import { render } from "./PoiDetails.vue?vue&type=template&id=0d255c3d&scoped=true"
import script from "./PoiDetails.vue?vue&type=script&lang=js"
export * from "./PoiDetails.vue?vue&type=script&lang=js"

import "./PoiDetails.vue?vue&type=style&index=0&id=0d255c3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d255c3d"]])

export default __exports__